import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FacebookPost } from './facebook.post';

@Component({
    selector: 'ig-facebook-post',
    templateUrl: './facebook.post.component.html',
    styleUrls: ['./facebook.post.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FacebookPostComponent {
    @Input() public post: FacebookPost;
    public messageLength = 220;

    constructor() {
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/facebook.post/facebook.post.component.ts